import BlockComponent from "./BlockComponent";

import React from "react";
import Image from "next/image";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import images from "@data/photosCarousselLeClub";

const HistoireDuClub: React.FC = () => {
  const [emblaRef, embla] = useEmblaCarousel({ skipSnaps: false, loop: true }, [Autoplay({ delay: 3000 })]);

  let randomizedPhotosCaroussel = images
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

  return (
    <BlockComponent titre="Notre histoire">
      <div id="histoire-texte-image-container-1" className="flex flex-col gap-16 lg:flex-row">
        <div id="histoire-texte-image-container-1-paragraphe" className={`flex flex-col justify-evenly space-y-4 text-justify text-whiteAccent/80 lg:w-3/4`}>
          <p>
            Structuré en tant que club d’esport en <span className="font-semibold text-redAccent">2019</span>, sur la base d’une communauté existante depuis 2001, DeathroW a toujours été vecteur de nombreuses valeurs et prôné <span className="font-semibold text-redAccent">l’éducation à travers les jeux vidéo</span>. L’objectif du club est désormais <span className="font-semibold text-redAccent">d’accompagner</span>, dans leurs études, dans leur vie, et dans l'esport, <span className="font-semibold text-redAccent">des jeunes talents</span> ayant le potentiel pour atteindre le sommet.
          </p>
          <p>
            <span className="font-semibold text-redAccent">L'amélioration des conditions d'entraînement</span> et <span className="font-semibold text-redAccent">l'optimisation des performances</span> sont au cœur de notre projet. S'entraîner moins pour s'entraîner mieux, et ainsi se concentrer sur les études, la vie sociale, et les phases de repos : <span className="font-semibold text-redAccent">telle est notre philosophie</span>.
          </p>
        </div>

        <div id="histoire-carousel" className="embla w-full select-none rounded lg:w-1/3">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {randomizedPhotosCaroussel.map((image, key) => {
                return (
                  <div key={key} className="embla__slide overflow-hidden">
                    <div className="relative aspect-video overflow-hidden">
                      <Image placeholder="blur" blurDataURL={image.img} alt={image.legende} src={image.img} className="h-full w-full transform rounded object-cover object-center shadow-2xl" layout="fill" quality={70} />
                      <div id="legende-photo" className="absolute bottom-0 flex w-full items-center justify-center bg-darkCard py-1 text-center text-xs tracking-wide text-whiteAccent/40">
                        <span>
                          {image.legende} - © {image.credit}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </BlockComponent>
  );
};

export default HistoireDuClub;
